import { supabase } from '../supabase';

export interface DbConsultant {
  id: string;
  email: string;
  name: string;
  created_at: string;
}

export async function getAllConsultants(): Promise<DbConsultant[]> {
  const { data, error } = await supabase
    .from('profiles')
    .select('id, email, name, created_at')
    .in('role', ['owner', 'consultant'])
    .eq('active', true)
    .order('name', { ascending: true });

  if (error) {
    console.error('Error fetching consultants:', error);
    return [];
  }

  return data || [];
}

export async function getConsultant(id: string): Promise<DbConsultant | null> {
  const { data, error } = await supabase
    .from('profiles')
    .select('id, email, name, created_at')
    .eq('id', id)
    .in('role', ['owner', 'consultant'])
    .eq('active', true)
    .maybeSingle();

  if (error) {
    console.error('Error fetching consultant:', error);
    return null;
  }

  return data;
}
